const userQuestionAnswer = {
    getall: 'UserQuestionAnswer/getall',
}
export default userQuestionAnswer
